import styled from 'styled-components'
import theme from '../../theme/theme';

export const MainHeader = styled.h1`
color: ${theme.color.navy};
font-size: 3rem;
font-weight: 700;
margin-bottom: 5px;

@media (max-width: 400px) {
    font-size: 2rem;
    justify-content: center;
    margin-right: 50px;
}
`;

export const HeaderContainer = styled.div`
margin-left: 10%;
width: 80%;
border-bottom: 1px solid ${theme.color.silver};
margin-bottom: 30px;

@media (max-width: 800px) {
    margin-left: 10px;
    width: 97%;
}
`;

export const ReservationContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
margin: 0;
`;

export const DateWrapper = styled.span`
    font-size: 2.5rem;
    font-weight: 300;
    margin-left: 20px;

    @media (max-width: 400px) {
        font-size: 1.5rem;
        margin-left: 0px;
    }
`;